import { createContext, useContext } from 'react';
import type { AuthContextValue } from './AuthContext';

/**
 * Round 153 - the learner auth context OBJECT lives here, in a module that imports nothing from Firebase, so a small component (the navigation) can
 * read it, tolerantly, without loading the Firebase config (which a Jest test of that component cannot).
 */
export const AuthContextRef = createContext<AuthContextValue | null>(null);

/** the context, or null when the component is rendered without a provider (a test, a preview) */
export function useOptionalAuthContext(): AuthContextValue | null {
  return useContext(AuthContextRef);
}
